export const policyImplementationStatusOptions = [
    {
        label: "All",
        value: "ALL"
    },
    {
        label: "In Force",
        value: "IN_FORCE"
    },
    {
        label: "Repealed",
        value: "REPEALED"
    },
    {
        label: "Amended",
        value: "AMENDED"
    },
];